import { NavLink as MantineNavLink, Stack } from '@mantine/core';
import { NavLink as RRNavLink } from 'react-router';
import { ExternalLinkIcon } from 'lucide-react';

import * as classes from './mobile-navigation.css';
import { NavItem, NavSubItem } from './types';

export function Navigation({
  navItems,
  onLinkClick,
}: {
  navItems: NavItem[] | undefined;
  onLinkClick: () => void;
}) {
  if (!navItems) {
    return null;
  }

  return (
    <Stack gap="0.125rem">
      {navItems.map((item) =>
        item.subItems ? (
          <MantineNavLink
            key={item.id}
            classNames={{ root: classes.navLink }}
            label={item.label}
            defaultOpened
          >
            <Stack gap="0.125rem">
              {item.subItems.map((subItem) => (
                <NavLink key={subItem.id} item={subItem} onLinkClick={onLinkClick} />
              ))}
            </Stack>
          </MantineNavLink>
        ) : (
          <NavLink key={item.id} item={item} onLinkClick={onLinkClick} />
        ),
      )}
    </Stack>
  );
}

function NavLink({ item, onLinkClick }: { item: NavSubItem; onLinkClick: () => void }) {
  const { label, Icon, href, target, to } = item;

  if (href) {
    return (
      <MantineNavLink
        classNames={{ root: classes.navLink }}
        label={label}
        leftSection={Icon && <Icon size={14} />}
        component="a"
        href={href}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        rightSection={target === '_blank' && <ExternalLinkIcon size={14} />}
        onClick={onLinkClick}
      />
    );
  }

  if (to) {
    return (
      <MantineNavLink
        classNames={{ root: classes.navLink }}
        label={label}
        leftSection={Icon && <Icon size={14} />}
        component={RRNavLink}
        to={to}
        onClick={onLinkClick}
      />
    );
  }
  return <MantineNavLink label={label} leftSection={Icon && <Icon size={14} />} />;
}
